<div class="body-shell">

  <app-navbar></app-navbar>

  <div class="d-flex" id="wrapper" [ngClass]="{'toggled':toggled}">
    <app-admin-sidebar *authenticatedWithRole="['ROLE_HUB']"></app-admin-sidebar>
    <app-organisation-sidebar *authenticatedWithRole="['ROLE_ORGANISATION']"></app-organisation-sidebar>
    <app-facilitator-sidebar *authenticatedWithRole="['ROLE_FACILITATOR']"></app-facilitator-sidebar>
    <div id="page-content-wrapper">
      <div class="body-content container-fluid p-0" #pageTop>
        <router-outlet (activate)="onActivate(pageTop)"></router-outlet>
      </div>
    </div>
  </div>

  <div class="footer">
    <hr class="dropdown-divider border-success w-60">
    <a class="font-size-small cursor-pointer text-dark">©The Greenlight Office</a>
    |
    <a class="font-size-small cursor-pointer text-dark">Legal</a>
    |
    <a class="font-size-small cursor-pointer text-dark" routerLink="privacy">Privacy</a>
    <hr class="dropdown-divider border-success w-10">
  </div>

</div>
